<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="isCourseVisible(data)">
    <!-- CONTENT -->

    <div class="coursesPage" id="scroll-overview">

      <section class="coursesPage-top" [class.fixed]="isFixed"
        [ngStyle]="{'background': data?.tenant?.brandTheme?.salesPageBannerColor === 'undefined' ? '#11294F' : data?.tenant?.brandTheme?.salesPageBannerColor}">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-12  col-lg-7">
              <div class="courseContent-box">
                <div class="course-scroll-title"
                  [ngStyle]="{'background': data?.tenant?.brandTheme?.salesPageBannerColor === 'undefined' ? '#11294F' : data?.tenant?.brandTheme?.salesPageBannerColor}">
                  <img class="course-thumbnail-small" [src]="thumbnailUrl(data?.course)" />
                  <div class="course-title">
                    <h1>{{ data.course.title }}</h1>
                    <p>{{ data.course.subTitle }}</p>
                  </div>
                </div>

                <div class="authorsDetails-wrapper">
                  <ul class="authorsDetails">
                    <li class="auothorDetails__bio">

                      <ng-container *ngFor="let author of data.courseAuthors">

                        <img class="author_img" [src]="author.pictureUrl" *ngIf="author.pictureUrl" />

                      </ng-container>

                      <div class="author_createDate" *ngIf="data.courseAuthors.length > 0">
                        <p>{{ "course.createdBy" | translate }}</p>
                        <a class="author-link" routerLink="." [fragment]="author.id"
                          *ngFor="let author of data.courseAuthors">{{ author.name }}</a>
                      </div>
                    </li>
                    <li *ngIf="data.course.free">
                      <div class="authorCourse-state">{{ "course.freeCourseLabel" | translate }}</div>
                    </li>
                    <li class="author__totalHrs" *ngIf="data?.course?.totalDuration && !data?.course?.hideDuration">
                      <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/time%20(1).svg" />

                      <span>{{data.course.totalDuration | duration : "hours"}}h</span>

                    </li>
                    <li class="author__totalLang" *ngIf="data?.captionsList">
                      <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/language.svg" alt="" />
                      <span>
                        {{ data?.captionsList }}
                      </span>
                      <!-- <span
                        class="totalLangCount"
                        *ngIf="data.captionsList.length > 2"
                      >
                        +{{ data?.captionsList.length - 2 }}
                      </span> -->
                    </li>
                  </ul>
                </div>

                <div class="courseContent-tab"
                  [ngStyle]="{'background': data?.tenant?.brandTheme?.salesPageBannerColor === 'undefined' ? '#11294F' : data?.tenant?.brandTheme?.salesPageBannerColor}"
                  #navigationTab>

                  <mat-tab-group #tabGroup (selectedIndexChange)="scrollTo(navigationTab, $event)">
                    <mat-tab [label]="'course.tabs.overview' | translate"></mat-tab>
                    <mat-tab [label]="'course.tabs.content' | translate"></mat-tab>
                    <mat-tab [label]="'course.tabs.description' | translate"></mat-tab>
                    <mat-tab [label]="'course.tabs.about' | translate"></mat-tab>
                  </mat-tab-group>

                </div>
              </div>
            </div>

            <div class="col-12 col col-sm-12 col-lg-3">
              <div class="pricing-card">
                <!-- <div class="course-btns edit-course-container" *ngIf="isCourseEditable(data)">
                  <button class="edit-course" mat-raised-button color="accent" matTooltip="Edit course"
                    [routerLink]="['/edit-courses', data.course.url, 'edit']">
                    <div class="btn-contain d-flex align-items-center">
                      <img [src]="iconImgUrl">
                      {{ "course.editCourseButton" | translate }}
                    </div>
                  </button>
                </div> -->
                <div class="pricing-info">
                  <div class="pricing-info-top">
                    <a class="play" (click)="
                        onPlaySampleLesson(
                          data.course,
                          data.sections,
                          data.lessons
                        )
                      ">
                      <div class="play-video">
                        <svg>
                          <use xlink:href="#watchIcon"></use>
                        </svg>
                      </div>
                      <p class="marginb-0 mt-3" *ngIf="!data?.course?.free">
                        {{ "course.viewPreviewButton" | translate }}
                      </p>
                    </a>
                    <img class="img-fluid course-thumbnail ng-star-inserted" *ngIf="data.course.thumbnail"
                      [src]="thumbnailUrl(data.course)" />
                    <img class="img-fluid course-thumbnail" *ngIf="!data.course.thumbnail" [src]="emptyImg()" />
                  </div>

                  <div class="pricing-info-bottom">
                    <div class="course-price" *ngIf="!data.course.free">
                      <ng-template #undiscountedPrice>
                        <div class="course-price">
                          <h2 *ngIf="data.course.price">
                            {{
                            data.course.price
                            | currency
                            : data?.tenant?.currency
                            : "symbol-narrow"
                            : "1.0-2"
                            }}
                          </h2>
                        </div>
                      </ng-template>
                      <div class="course-coupon-discount" *ngIf="!data?.coupon?.free">
                        <ng-container *ngIf="data?.couponValid; else undiscountedPrice">
                          <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="course-price">
                              <h2 class="course-discounted-price">
                                {{
                                data?.coupon?.price
                                | currency
                                : data?.tenant?.currency
                                : "symbol-narrow"
                                : "1.0-2"
                                }}
                              </h2>
                            </div>
                            <div class="course-price-right" *ngIf="data?.couponValid; else undiscountedPrice">
                              <div class="discounted-price">
                                <p class="course-original-price">
                                  <s>{{
                                    data.course.price
                                    | currency
                                    : data?.tenant?.currency
                                    : "symbol-narrow"
                                    : "1.0-2"
                                    }}</s>
                                </p>
                                <span class="course-discounted-pricePer" *ngIf="!data?.coupon?.free">
                                  {{
                                  "course.couponDiscountPercentage"
                                  | translate
                                  : {
                                  discountPercentage:
                                  calculateDiscountPercentage(
                                  data.course,
                                  data?.coupon
                                  )
                                  }
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <div class="course-btns" *ngIf="!(data.course.privateCourseOn || data?.course.hiddenCourseOn)">
                          <button class="course-buy" mat-raised-button (click)="onBuyCourseScrolledMobile(data)"
                            [ngStyle]="{'background-color': data?.tenant?.brandTheme?.accentColor }">
                            <mat-icon>shopping_cart</mat-icon>
                            <span>{{ 'course.courseActionButtons.buyStripe' | translate }}</span>
                          </button>
                        </div>

                      </div>
                    </div>

                    <ng-container *ngIf="data?.coupon; else undiscountedPrice">

                      <div class="coupon-applied d-flex align-items-center justify-content-center"
                        *ngIf="data?.couponValid">

                        <span class="material-symbols-outlined">
                          thumb_up
                        </span>
                        <span class="coupon-applied-title"
                          [innerHTML]="'course.couponApplied' | translate: { couponCode: '<strong>' + (data?.coupon?.code || '') + '</strong>' }"></span>

                        <!-- <span class="coupon-applied-title" > {{ 'course.couponApplied' | translate: {couponCode: data?.coupon?.code} }}</span> -->

                      </div>
                      <div class="validity" *ngIf="data?.coupon?.deadline; else undiscountedPrice">
                        <div class="valid-until d-flex align-items-start justify-content-center">
                          <mat-icon>error</mat-icon>
                          <span
                            [innerHTML]="'course.couponExpiresOn' | translate: {expiresAt:data?.coupon?.deadline.toDate() | date : 'MMM d, YYYY', daysLeft: getDaysLeft(data?.coupon?.deadline)}">

                          </span>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="data?.coupon?.free">
                      <div class="course-price">
                        <div class="course-coupon-discount course-coupon-freeDiscount">
                          <div class="course-price">
                            <h2 class="course-discounted-price">
                              <s> {{ data.course.price | currency : data?.tenant?.currency : "symbol-narrow" : "1.0-2"
                                }}</s>
                            </h2>
                          </div>
                          <div class="course-price-right">
                            <span class="free-now">{{ 'course.nowFree' | translate }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="course-btns">
                        <button class="course-watch " mat-raised-button (click)="onClaimFreeCourseCoupon(data)">
                          <div class="d-flex">
                            <div class="watch-icon btn-icon">
                              <svg>
                                <use xlink:href="#watchIcon"></use>
                              </svg>
                            </div>
                            {{
                            "course.courseActionButtons.claimFreeCourse"
                            | translate
                            }}
                          </div>
                        </button>
                        <button class="course-sub" mat-raised-button *ngIf="isSubscribeButtonVisible(data)"
                          routerLink="/subscription"
                          [ngStyle]="{'background-color': data?.tenant?.brandTheme?.primaryColor }">
                          {{ 'course.courseActionButtons.subscribe' | translate }}
                        </button>
                      </div>

                    </ng-container>

                    <ng-container *ngIf="data?.course?.free && !data?.coupon?.free">

                      <div class="course-btns">
                        <button class="course-watch" mat-raised-button (click)="startCourse(data)">
                          <div class="d-flex">
                            <div class="watch-icon btn-icon">
                              <svg>
                                <use xlink:href="#watchIcon"></use>
                              </svg>
                            </div>
                            {{
                            "course.courseActionButtons.watchFreeCourse"
                            | translate
                            }}
                          </div>
                        </button>
                        <button class="course-sub" mat-raised-button *ngIf="isSubscribeButtonVisible(data)"
                          [ngStyle]="{'background-color': data?.tenant?.brandTheme?.primaryColor }"
                          routerLink="/subscription">
                          {{ 'course.courseActionButtons.subscribe' | translate }}
                        </button>
                      </div>

                    </ng-container>

                    <ng-container *ngIf="!data?.course?.privateCourseOn && !data?.course?.hiddenCourseOn">

                      <div class="course-btns" *ngIf="!data.course.free && !data?.coupon?.free">

                        <ng-container *ngIf="!data?.canUserAccessCourse">

                          <button class="paypal" mat-raised-button (click)="onStartPaypalPurchase(data)"
                            *ngIf="data.tenant?.paypalConfig?.enabled">
                            <img src="https://d8avu785lzlph.cloudfront.net/images/neo-img/paypal.svg" />
                          </button>

                          <button class="course-buy" mat-raised-button (click)="onBuyCourseWithStripe(data)"
                            *ngIf="data.tenant.isConnectedToStripe && !data.tenant?.paypalConfig?.enabled"
                            [ngStyle]="{'background-color': data?.tenant?.brandTheme?.accentColor }">
                            {{ 'course.courseActionButtons.buyStripe' | translate }}
                          </button>

                          <button class="course-sub" mat-raised-button routerLink="/subscription"
                            *ngIf="isSubscribeButtonVisible(data)"
                            [ngStyle]="{'background-color': data?.tenant?.brandTheme?.primaryColor }">
                            {{ 'course.courseActionButtons.subscribe' | translate }}
                          </button>

                        </ng-container>

                        <ng-container *ngIf="data?.canUserAccessCourse">

                          <button class="course-watch" mat-raised-button (click)="startCourse(data)">

                            <div class="d-flex">
                              <div class="watch-icon btn-icon">
                                <svg>
                                  <use xlink:href="#watchIcon"></use>
                                </svg>
                              </div>
                              {{ 'course.courseActionButtons.startCourse' | translate }}
                            </div>
                          </button>

                        </ng-container>

                      </div>

                    </ng-container>

                    <div class="money-back" *ngIf="data?.tenant?.guaranteeOffered && !data?.course.free">

                      <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/shield%20(1).svg" />

                      <span>{{
                        "course.guaranteeDays"
                        | translate
                        : {guaranteeDays: data?.tenant?.guaranteeDays}
                        }}</span>
                    </div>

                    <div class="private-only d-flex align-items-center justify-content-between"
                      *ngIf="data?.course?.privateCourseOn || data?.course?.hiddenCourseOn">
                      <h6 class="d-flex align-items-center">
                        <img [src]="awardUrl">
                        <span>{{ 'course.privateCourse' | translate}}</span>
                      </h6>
                      <span> {{ 'course.invitationOnly' | translate}}</span>
                    </div>

                    <ng-container *ngIf="!data.course.free">
                      <div class="course-btns redeem-coupon" *ngIf="!data?.coupon && !data.canUserAccessCourse">
                        <button class="coupon-redeem" mat-stroked-button (click)="onRedeemCoupon()">
                          <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/cut.svg" />
                          {{ "course.doYouHaveACouponToRedeem" | translate }}
                        </button>
                        <div class="coupon-code-container" *ngIf="redeemCouponBoxVisible">

                          <div class="apply-coupon">
                            <input class="coupon-box" [placeholder]="'course.enterCoupon' | translate"
                              (keydown.enter)="activateCoupon(data, couponCodeInput.value)" #couponCodeInput />

                            <button class="apply-btn" mat-stroked-button
                              (click)="activateCoupon(data, couponCodeInput.value)"
                              [ngStyle]="{'background-color': data?.tenant?.brandTheme?.accentColor }">
                              {{ "course.apply" | translate }}
                            </button>
                          </div>


                        </div>
                      </div>
                    </ng-container>

                    <div class="course-include">
                      <div class="course-title">
                        <h4>{{ "course.thisCourseIncludes" | translate }}</h4>
                      </div>
                      <ul>
                        <li *ngIf="data.course?.totalDuration && !data?.course?.hideDuration">
                          <span class="material-symbols-outlined">
                            schedule
                          </span>
                          <p>
                            {{
                            "course.totalDuration" | translate: {
                            totalDuration:
                            data.course.totalDuration
                            | duration : "hours"
                            }
                            }}
                          </p>
                        </li>
                        <li *ngIf="!data?.course?.lifetimeOfferTextOff">
                          <span class="material-symbols-outlined">
                            all_inclusive
                          </span>
                          <p>{{ "course.fullLifeTimeAccess" | translate }}</p>
                        </li>
                        <li>
                          <span class="material-symbols-outlined"> tv </span>
                          <p>{{ "course.accessOnMobileAndTV" | translate }}</p>
                        </li>
                        <li *ngIf="isCertificatesActive(data)">
                          <span class="material-symbols-outlined">
                            verified
                          </span>
                          <p>
                            {{ "course.certificateOfCompletion" | translate }}
                          </p>
                        </li>
                        <li *ngIf="data.totalArticles">
                          <span class="material-symbols-outlined">article</span>
                          <p>
                            {{
                            "course.totalArticles"
                            | translate
                            : {totalArticles: data.totalArticles}
                            }}
                          </p>
                        </li>
                        <li *ngIf="data.captionsList">
                          <span class="material-symbols-outlined">
                            volume_up
                          </span>
                          <p>{{ data.captionsList }}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="coursesPage-top-sm-scroll"
        [ngStyle]="{'background': data?.tenant?.brandTheme?.salesPageBannerColor === 'undefined' ? '#11294F' : data?.tenant?.brandTheme?.salesPageBannerColor}">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="course-scroll-title">
                <img class="course-thumbnail-small" [src]="thumbnailUrl(data?.course)" />
                <div class="course-title">
                  <h1>{{ data.course.title }}</h1>
                  <p>{{ data.course.subTitle }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      <section class="courseContent-tab tab-mobile"
        [ngStyle]="{'background': data?.tenant?.brandTheme?.salesPageBannerColor === 'undefined' ? '#11294F' : data?.tenant?.brandTheme?.salesPageBannerColor}"
        #mobileNavigationTab>
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col col-lg-7">

            </div>
            <div class="col col-sm-12 col-lg-3"></div>
          </div>
        </div>
      </section>
      <section class="coursesPage-middle">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-lg-7">
              <div class="courseContent-box">
                <div class="course-title">
                  <h4>
                    {{ "course.whatIsIncludeInThisCourse" | translate }}
                  </h4>
                </div>

                <div class="no-features" *ngIf="!data.course?.features?.length">
                  {{
                  "course.enterTheCourseMainFeatureInTheLandingPage"
                  | translate
                  }}
                  <a [routerLink]="['/edit-courses', data.course.url, 'edit']">{{ "course.editCourseButton" | translate
                    }}</a>
                  {{ "course.screen" | translate }}
                </div>

                <div class="courseFeature-list" id="scroll-content">

                  <ul>
                    <li *ngFor="let feature of data.course?.features">
                      <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/Checkmark.svg"
                        alt="check" />
                      <span>
                        {{ feature }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              <!--course content start-->
              <div class="courseContent-boxWidget">
                <div class="course-title course-titleIcon">
                  <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/Vector.svg" alt="" />
                  <h4>{{ "course.courseContent" | translate }}</h4>
                </div>

                <ng-container *ngIf="data.sections as sections">

                  <ng-container *ngIf="sections.length > 0">
                    <course-content [course]="data.course" [sections]="sections"
                      [sectionsLessons]="data.sectionsLessons" [lessonsWatched]="data.lessonsWatched">
                    </course-content>
                  </ng-container>
                </ng-container>
              </div>
            </div>
            <div class="col-sm-12 col-lg-3"></div>
          </div>
        </div>
      </section>

      <section class="coursesPage-bottom">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-lg-7">
              <div class="courseContent-boxWidget">
                <div class="course-title course-titleIcon">

                  <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/Vector.svg" />

                  <h4 id="scroll-description">{{ "course.descriptionSection" | translate }}</h4>

                </div>
                <div class="courseContent-box">
                  <div class="cdbx text-overflow" *ngIf="
                      courseDescription$ | async as courseDescription;
                      else noLongDescription">
                    <view-html class="message-text html-content" [content]="courseDescription"></view-html>
                  </div>
                  <ng-template #noLongDescription>
                    <div class="no-long-description">
                      <i>{{
                        "course.theCourseLongDescriptionGoesHere" | translate
                        }}
                        <a [routerLink]="[
                            '/edit-courses',
                            data.course.url,
                            'edit'
                          ]">{{ "course.editCourseButton" | translate }}</a>
                        {{ "course.screenMandatory" | translate }}</i>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div>

                <div id="scroll-about" class="scroll-anchor"></div>

                <div class="courseContent-boxWidget" *ngFor="let author of data.courseAuthors">
                  <div class="course-title course-titleIcon">
                    <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/Vector.svg" alt="" />
                    <h4 [id]="author.id">
                      {{ "course.instructor" | translate }}
                    </h4>
                  </div>
                  <div class="courseContent-author">
                    <div class="auothor_identity">
                      <img class="author_img" *ngIf="author.pictureUrl" [src]="author.pictureUrl" alt="" />
                      <div class="course-title">
                        <h4>{{ author.name }}</h4>
                        <p>{{ author.bioTitle }}</p>
                      </div>
                    </div>
                    <div class="author-bio">
                      <div class="html-content" [innerHTML]="author.bioText | safeHtml"></div>
                    </div>
                  </div>
                </div>
              </div>


              <!--FAQ-->
              <div class="courseContent-boxWidget" *ngIf="data.course.faqs.length">
                <div class="course-title course-titleIcon">
                  <img src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/Vector.svg" alt="" />
                  <h4>{{ "course.faqs" | translate }}</h4>
                </div>
                <div class="courseContent-faq">
                  <mat-accordion>
                    <mat-expansion-panel #panelRef *ngFor="let faq of data.course.faqs; let i = index"
                      [expanded]="i === 0" [ngClass]="{ 'expanded-panel': panelRef.expanded }">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <img class="faqIcon"
                            src="https://d8avu785lzlph.cloudfront.net/images/min-img/iconset/Question.svg" alt="" />
                          <div class="course-title">
                            <h4>{{ faq.question }}</h4>
                          </div>
                        </mat-panel-title>
                        <mat-icon>{{
                          panelRef.expanded ? "remove" : "add"
                          }}</mat-icon>
                      </mat-expansion-panel-header>
                      <p [innerHTML]="faq.answer | safeHtml"></p>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-lg-3"></div>
          </div>
        </div>
      </section>
    </div>

    <page-footer></page-footer>

  </ng-container>
</ng-container>